import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { UserIdCtor, type UserIdType } from '../types.js'
import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('UserPassword')
export class UserPassword {
	@jsonProperty(UserIdCtor)
	userId?: UserIdType

	@jsonProperty(String)
	passwordHash: string = ''
	@jsonProperty(String)
	recoveryTokenHash: string = ''
	@jsonProperty(Date)
	recoveryTokenValidUntil?: Date

	constructor(init?: Partial<UserPassword>) {
		assignCommonProperties(this, init)
	}
}
